<template>
  <div>
    <div>
      <i18n
        tag="p"
        class="Fuell-Text"
        path="transactions_reimbursements_users_pending_explanation"
      ></i18n>
    </div>

    <div class="Fuell-Toolbar justify-content-between">
      <div class="d-flex toolbar-column">
        <entity-search-input @search="fetchUserTransactions"></entity-search-input>
        <date-select-reference
          type="expense"
          usersGrouping
        ></date-select-reference>
      </div>
      <div class="d-flex toolbar-column">
        <transactions-view-group
          :activeView.sync="activeView"
          @changeView="changeView"
        ></transactions-view-group>
        <button
          class="Fuell-ToolbarButton ml-3"
          @click="showAccountingClosureModal"
          v-if="!isUser && !isSuperBook"
        >
          <span class="Fuell-ToolbarButton--icon">
            <img
              :src="require('@/assets/img/icons/icon-agencia-tributaria.svg')"
              alt="columns"
            />
          </span>
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{path :'transactions_action_close_accounting_periods'}"
          >
          </span>
        </button>
      </div>
    </div>
    <transactions-table
      :tableName="tableName"
      :columns="columns"
      :showSelect="showTransactionSelect"
      :actionsList="actionsList"
      type="users"
      @fetchUserTransactions="fetchUserTransactions"
      @showReceiptModal="showReceiptModal"
      @showEditTransactionModal="showEditTransactionModal"
      @showMileageModal="showCreateMileageModal"
      @showDietModal="showDietModal"
      @showExpenseModal="showCreateExpenseModal"
      @goToPendingTransactions="goToPendingTransactions"
      @goToRefundableTransactions="goToRefundableTransactions"
      @goToNotRefundableTransactions="goToNotRefundableTransactions"
    ></transactions-table>
    <accounting-periods-closure-modal
      :open.sync="showAccountingClosureModalFlag"
      v-if="showAccountingClosureModalFlag"
    ></accounting-periods-closure-modal>
  </div>
</template>
<script>
import { REVIEW_STATUS, BULK_FUNNEL_ACTIONS } from '@/constants/reviewStatus'
import _transactionsIndexViewShared from '../../../_mixins/_transactionsIndexViewShared'
import _revissionFunnelActions from '../../../_mixins/funnel/_revissionFunnelActionsMixin'
import EntitySearchInput from '@/components/Commons/Search/EntitySearchInput'
import DateSelectReference from '../../../../../components/Commons/Forms/DateSelectReference.vue'
import transactionPeriodsMixin from '@/modules/transactions/_mixins/_transactionPeriods'
import TransactionsViewGroup from '@/modules/transactions/_components/_shared/TransactionsViewGroup.vue'
const AccountingPeriodsClosureModal = () => import('@/modules/accounting/_components/AccountingPeriodsClosureModal')

export default {
  name: 'ReimbursementsPendingUsers',
  mixins: [
    _transactionsIndexViewShared,
    _revissionFunnelActions,
    transactionPeriodsMixin
  ],
  components: {
    EntitySearchInput,
    AccountingPeriodsClosureModal,
    DateSelectReference,
    TransactionsViewGroup
  },
  props: {
    users: {
      type: Boolean,
      default: false
    },
    user: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      showTransactionExportModalFlag: false,
      showAccountingClosureModalFlag: false,
      showExpenseReceiptPreviewModalFlag: false,
      expenseMode: false,
      expenseType: '',
      defaultExportTab: 'EXPORT',
      tableName: 'users',
      activeView: 'users',
      actionsList: [
        BULK_FUNNEL_ACTIONS.APPROVE
      ]
    }
  },
  computed: {
    canReviewTransactions () {
      return this.$store.getters['LoginStore/isAdmin'] || this.$store.getters['LoginStore/isBookKeeper'] || (this.$store.getters['LoginStore/isUser'] && (this.$store.getters['LoginStore/isOwnerOfAnyBudget'] || this.$store.getters['LoginStore/isReviewer']))
    },
    canRejectTransactions () {
      return this.$store.getters['LoginStore/isAdmin'] || this.$store.getters['LoginStore/isBookKeeper'] || (this.$store.getters['LoginStore/isUser'] && (this.$store.getters['LoginStore/isOwnerOfAnyBudget'] || this.$store.getters['LoginStore/isReviewer']))
    },
    BULK_FUNNEL_ACTIONS () {
      return BULK_FUNNEL_ACTIONS
    },
    filters () {
      return { ...this.$store.getters['TransactionsStore/filters'] }
    }
  },
  methods: {
    goToPendingTransactions (event) {
      this.$router.push({
        name: 'reimbursements_pending_user_id',
        params: { userId: event }
      })
    },
    goToRefundableTransactions (event) {
      this.$router.push({
        name: 'reimbursements_pending_user_id',
        params: { userId: event },
        query: { 'expense.paymentMethod.officePaymentMethod.repayable': true }
      })
    },
    goToNotRefundableTransactions (event) {
      this.$router.push({
        name: 'reimbursements_pending_user_id',
        params: { userId: event },
        query: { 'expense.paymentMethod.officePaymentMethod.repayable': false }
      })
    },
    changeView (view) {
      this.$router.push({
        name: view === 'users' ? 'reimbursements_pending_users' : 'reimbursements_pending'
      })
    },
    async fetchUserTransactions (event) {
      let defaultFilters = {
        'order[user_id]': 'DESC',
        'type.code': 'EXPENSE',
        ...this.periods.find(el => el.id === 'historic').filter
      }
      if (this.filters['date[after]'] || this.filters['date[after]'] === null) {
        defaultFilters['date[after]'] = this.filters['date[after]']
      }
      if (this.filters['date[before]'] || this.filters['date[before]'] === null) {
        defaultFilters['date[before]'] = this.filters['date[before]']
      }
      if (this.isUser && this.userIsOwnerOfBudget) {
        defaultFilters['imOwnerOfBudget'] = true
      }
      defaultFilters['reviewStatus.code'] = [REVIEW_STATUS.AWAITING_REVIEW, REVIEW_STATUS.DRAFT, REVIEW_STATUS.OFFICE_FLOW_REVISION]
      defaultFilters['iCanReview'] = true

      let searchFilters = {}
      let force = false
      if (event && event.length >= 3) {
        searchFilters.query = event
      }
      let filters = event ? { ...defaultFilters, ...searchFilters } : { ...defaultFilters, ...searchFilters, ...this.parseQueryParams() }
      if (event && event.force) {
        force = true
      }

      await this.$store.dispatch('TransactionsStore/setTransactionsFilters', {
        filters: filters,
        force: force,
        users: true
      })
    }
  },
  mounted () {
    if (window.location.hash === '#exportHistory') {
      setTimeout(() => {
        this.showTransactionExportModalFlag = true
        this.defaultExportTab = 'HISTORY'
      }, 1500)
    }
  },
  watch: {
    '$route.path': function (val, oldVal) {
      this.initializeTransactions()
      this.changeViewValues()
    }
  }
}
</script>
<style src="@/assets/styles/multiselect/multiselect-section-selector.css" scoped>
</style>
<style lang="scss" src="@/assets/styles/dropdown/dropdowns.scss" scoped></style>
<style lang="scss" scoped>
.Fuell-Transactions--review-info-bar:nth-child(even) {
  margin-left: 24px;
}
</style>
<style>
.transaction-dashboard-container {
  max-width: 600px;
  width: 100%;
}

.remove-container {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

.large-dropdown .Fuell-Dropdown--container {
  position: absolute;
  width: 230px;
  text-align: left;
}
.large-dropdown .list-item {
  display: flex;
  justify-content: flex-start;
  margin: 10px 0px;
}
.large-dropdown .list-item .icon {
  margin-right: 10px;
}
.icon-diet {
  max-width: 17px;
  max-height: 17px;
}

.Fuell-ToolbarButton.success {
  background-color: var(--success);
  color: var(--fill-main-background);
}

.Fuell-ToolbarButton.danger {
  background-color: var(--danger);
  color: var(--fill-main-background);
}
</style>
